import { render, staticRenderFns } from "./KioskMediaManager.vue?vue&type=template&id=2f8fcc8b&"
import script from "./KioskMediaManager.vue?vue&type=script&lang=js&"
export * from "./KioskMediaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports